<template lang="pug">
  .text-center.neutral700--text
    v-icon.mb-5(size="55" color="success500") $yzi-gift-02
    template(v-if="customer && redeemedReward")
      .text-md.font-semibold.mb-4 {{ customer.name }} has redeemed 1 reward!
      y-chip.round-xl.pa-4.bg-color.d-block.mb-4
        .d-flex
          v-icon(color="success500") $yzi-gift-02
          .text-left.ml-3
            .text-sm 1 reward redeemed:
            ul
              li.text-sm(v-if="loyaltySystem === 'stamps'") {{ redeemedReward.name }}
              li.text-sm(v-else) {{ redeemedReward.rebate_amount | displayPrice }} Rebate
      simple-profile(:name="customer.name" :phone="customer.phone")
      v-card.pa-4.round-xl.mt-4(outlined)
        .d-flex.align-center.justify-space-between
          .d-flex.align-center.mr-4
            v-icon(size="20" color="neutral700") $yzi-link-01
            .text-xs.text-left.ml-3 Share link to customer’s loyalty profile. Link is unique.
          .text-xs.underline.font-semibold.cursor-pointer.hover-bg.no-wrap(@click="copyLink(member)") Copy link
      .text-center.mt-8
        v-btn.button-md.white--text.mb-4(color="neutral700" depressed @click="")
          v-icon.mr-2 $yzi-message-text-square-02
          div Send review request
        v-btn.button-md.underline(color="neutral700" text @click="handleBackToCollectPage") Back to collect page
      div(ref="copy")
    template(v-else)
      v-skeleton-loader(type="list-item-two-line@3")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SimpleProfile from "@/components/marketing/merchantapp/SimpleProfile.vue";

export default {
  components: {SimpleProfile},
  props: {
    customer: {
      type: Object,
      required: true,
    },
    redeemedReward: {
      type: Object,
      default: null,
    },
    member: {
      type: Object,
      required: (() => {})
    },
    loyaltySystem: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    getLoyaltyLink (member) {
      return `https://${this.company.slug}.yezza.co/loyalty/${member.pid}`
    },
    copyLink (member) {
      let url = this.getLoyaltyLink(member)
      let container = this.$refs.copy
      this.$copyText(url, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
    handleBackToCollectPage() {
      this.$router.push('/admin/marketing/merchant-app/collect').catch(() => {})
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.bg-color {
  background-color: #E9FFE6 !important
}
</style>